import kbpgp from 'kbpgp'

const F = kbpgp.const.openpgp

export const PROGRESS = {
  START_GENERATION: 'START_GENERATION',
  FINDING_PRIME: 'FINDING_PRIME',
  FOUND_PRIME: 'FOUND_PRIME',
  END_GENERATION: 'END_GENERATION',
  START_SIGNING: 'START_SIGNING',
  END_SIGNING: 'END_SIGNING',
  START_EXPORT_PUBLIC: 'START_EXPORT_PUBLIC',
  END_EXPORT_PUBLIC: 'END_EXPORT_PUBLIC',
  START_EXPORT_PRIVATE: 'START_EXPORT_PRIVATE',
  END_EXPORT_PRIVATE: 'END_EXPORT_PRIVATE',
}

export const KEY_STRENGTHS = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
}

export const KEYGEN_OPTIONS = {
  [KEY_STRENGTHS.LOW]: {
    primary: {
      nbits: 1024,
      flags:
        F.certify_keys |
        F.sign_data |
        F.auth |
        F.encrypt_comm |
        F.encrypt_storage,
      expire_in: 0, // never expire
    },
    subkeys: [
      {
        nbits: 512,
        flags: F.sign_data,
        expire_in: 0, // never expire
      },
      {
        nbits: 512,
        flags: F.encrypt_comm | F.encrypt_storage,
        expire_in: 0, // never expire
      },
    ],
  },
  [KEY_STRENGTHS.MEDIUM]: {
    primary: {
      nbits: 2048,
      flags:
        F.certify_keys |
        F.sign_data |
        F.auth |
        F.encrypt_comm |
        F.encrypt_storage,
      expire_in: 0, // never expire
    },
    subkeys: [
      {
        nbits: 1024,
        flags: F.sign_data,
        expire_in: 0, // never expire
      },
      {
        nbits: 1024,
        flags: F.encrypt_comm | F.encrypt_storage,
        expire_in: 0, // never expire
      },
    ],
  },
  [KEY_STRENGTHS.HIGH]: {
    primary: {
      nbits: 4096,
      flags:
        F.certify_keys |
        F.sign_data |
        F.auth |
        F.encrypt_comm |
        F.encrypt_storage,
      expire_in: 0, // never expire
    },
    subkeys: [
      {
        nbits: 2048,
        flags: F.sign_data,
        expire_in: 0, // never expire
      },
      {
        nbits: 2048,
        flags: F.encrypt_comm | F.encrypt_storage,
        expire_in: 0, // never expire
      },
    ],
  },
}
